// src/components/chat/TeamInviteStatusModal.jsx
// Modal showing terminal team invite status (accepted/declined/expired).
import React from 'react';

export default function TeamInviteStatusModal({ open, message, onClose }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
      <div className="w-[520px] max-w-[90vw] rounded-xl bg-white shadow-2xl border border-gray-200">
        <div className="px-5 py-4 border-b border-gray-200">
          <h3 className="text-base font-semibold text-[#00aef7]">
            Team Invitation
          </h3>
        </div>
        <div className="px-5 py-5">
          <p className="text-sm text-gray-800 whitespace-pre-line">
            {message}
          </p>
        </div>
        <div className="px-5 py-4 border-t border-gray-200 flex justify-end">
          <button
            type="button"
            className="px-4 py-2 rounded-md bg-[#00aef7] text-white hover:bg-[#099ad9]"
            onClick={onClose}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
